import { isEnabled } from 'Config';
import { getInstance as getConfigServiceInstance } from 'Lib/ConfigService';
import { LEVER_FRIENDS_OF_FRIENDS_VARIANT } from 'Lib/ConfigService/levers';
import { contactPickerSupported } from 'Lib/constants/browser';

import { LEVER_FRIENDS_OF_FRIENDS_VARIANT_ENABLED } from 'Store/mutualFriends/constants';

export const isMutualFriendsEnabledAndSupported = () =>
  isEnabled('mutualFriends') &&
  contactPickerSupported &&
  getConfigServiceInstance().readLever(LEVER_FRIENDS_OF_FRIENDS_VARIANT) ===
    LEVER_FRIENDS_OF_FRIENDS_VARIANT_ENABLED;
